export default '/build/dd03c54a.svg'